/**
 * Lux inject for tenant rent plan editor:
 * /properties/{propertyHrId}/edit/unit/{unitId}/contract/all/edit/{contractId}/rent-plan/{rentPlanId}/edit
 */
const onRentPlanEditPageMatch = (pathname) => {
  const m = pathname.match(
    /\/rent-plan\/([^/]+)\/edit$/
  )
  const rentPlanId = m ? m[1] : null

  const tryInject = () => {
    injectNebenkostenPauschale({ rentPlanId })
  }

  tryInject()

  if (document.querySelector('[data-lux-inject="nebenkosten-pauschale"]')) {
    return
  }

  const obs = new MutationObserver(() => {
    tryInject()
    if (document.querySelector('[data-lux-inject="nebenkosten-pauschale"]')) {
      obs.disconnect()
    }
  })
  obs.observe(document.body, { childList: true, subtree: true })

  window.setTimeout(() => {
    obs.disconnect()
  }, 60000)
}
